import Signal from "libs/signals";

const $capitalCallPortionsList = Signal({
  capitalCallPortions: [],
});

export default $capitalCallPortionsList;
